import React from "react";
import AboutTyre from '../assets/Bg-Vid-21.webm';
import { useNavigate } from "react-router-dom";

const About = ({ showButton = true }) => {
  const navigate = useNavigate();

  return (
    <section className="about-section" >
      <div className="video-background">
        <video 
          className="background-video"
          autoPlay 
          loop 
          muted 
          playsInline
          preload="metadata"
        >
          <source src={AboutTyre} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="video-overlay"></div>
      </div>
      <div className="about-container">
        <div className="about-content">
          <div className="about-white-container">
            <div className="about-text-content">
              <div className="about-header">
                <span className="about-label">ABOUT US</span>
                <h2 className="about-title">CAR FORENSICS LTD</h2>
              </div>
              
              <div className="about-text">
                <p>
                  We are a family-run mobile garage and car forensics company with over 15 years of experience in car diagnostics, ECU remapping, ECU repair, and vehicle maintenance. Our long-standing reputation is built on technical expertise, honest advice, and consistently high standards of work across Kent and Milton Keynes.
                </p>

                <p>
                  Customer care is central to what we do, and our loyal repeat customers reflect the quality of service we provide. When you choose us, you can expect a professional mobile mechanic service delivered with skill, reliability, and attention to detail.
                </p>

                <p>
                  As a fully equipped mobile garage, we bring our workshop directly to you — whether you’re at home, work, or stranded at the roadside. This saves you time and removes the inconvenience of towing or waiting at a local garage.
                </p>

                <p>
                  We offer a comprehensive range of services including advanced car and vehicle diagnostics, ECU remapping and engine tuning, programming and coding, ECU testing and repair, and specialist car forensics. Using the latest diagnostic equipment, we accurately identify faults such as warning lights, engine management issues, and electronic system errors across all vehicle makes and models.
                </p>

                <p>
                  If you’re unsure what your vehicle needs, our experienced team is always happy to help. Simply get in touch and we’ll carry out a thorough diagnostic inspection to ensure the fault is correctly identified and resolved.
                </p>

                <p>
                  As trusted mobile garage specialists in Kent and Milton Keynes, we’re known for our fast response, technical knowledge, and dependable service. From routine diagnostic checks to complex ECU repairs and remapping, you can be confident your vehicle is in safe hands.
                </p>

                <p>
                  We also welcome fleet vehicles, lease cars, and commercial traders, and offer 24/7 emergency call-out services when urgent assistance is required.
                </p>

                <p>
                  <a href="tel:+447501911970" className="call-link">Call us today</a> 
                  and our team will thoroughly diagnose your vehicle to ensure accurate identification and resolution of any issues.
                </p>

                {showButton && ( 
                  <button 
                    className="read-more-btn"
                    onClick={() => navigate("/about")}
                  >
                    Read More
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="contact-sec">
          <div className="contact-intro">
            <p>Get in touch today for mobile garage services in Kent & Milton Keynes!</p>
          </div>
          
          <div className="contact-info">
            <div className="contact-item phone">
              <div className="contact-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" style={{fill: 'var(--text-light)'}}/>
                </svg>
              </div>
              <div className="contact-text">
                <span className="contact-label">Call Us Now :</span>
                <a href="tel:+447501911970" className="contact-value">+447501911970</a>
              </div>
            </div>

            <div className="contact-item email">
              <div className="contact-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" style={{fill: 'var(--text-light)'}}/>
                  <polyline points="22,6 12,13 2,6" style={{fill: 'var(--accent-color)'}}/>
                </svg>
              </div>
              <div className="contact-text">
                <span className="contact-label">Email :</span>
                <a href="mailto:carforensicsltd@gmail.com" className="contact-value">carforensicsltd@gmail.com</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
     .about-section {
  background-color: var(--primary-color);
  padding: 80px 0;
  font-family: inherit;
  position: relative;
  overflow: hidden;
}

.video-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.background-video {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  transform: translate(-50%, -50%);
  object-fit: cover;
  z-index: 1;
}

.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(45, 44, 46, 0.8);
  z-index: 2;
}

.about-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 60px;
  align-items: start;
  position: relative;
  z-index: 3;
}

.about-content {
  padding-right: 40px;
}

.about-white-container {
  background: var(--secondary-color);
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(212,246,0,0.15);
  padding: 40px;
}

.about-text-content {
  flex: 1;
}

.about-header {
  margin-bottom: 40px;
}

.about-label {
  color: var(--accent-color);
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  display: block;
  margin-bottom: 15px;
  position: relative;
}

.about-label::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -8px;
  width: 50px;
  height: 3px;
  background-color: var(--accent-color);
}

.about-title {
  font-size: 48px;
  font-weight: 700;
  color: var(--text-light);
  margin: 0;
  line-height: 1.1;
}

.about-text p {
  font-size: 16px;
  line-height: 1.8;
  color: #cfcfcf;
  margin-bottom: 24px;
  text-align: justify;
}

.call-link {
  color: var(--accent-color);
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
  margin: 0 5px;
  text-decoration: none;
}

.call-link:hover {
  color: var(--accent-hover);
}

.read-more-btn {
  background-color: var(--accent-color);
  color: var(--text-dark);
  border: none;
  padding: 15px 35px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-top: 20px;
}

.read-more-btn:hover {
  background-color: var(--accent-hover);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(212,246,0,0.18);
}

.contact-sec {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
  position: sticky;
  top: 100px;
}

.contact-intro {
  margin-bottom: 30px;
  text-align: center;
}

.contact-intro p {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-light);
  margin: 0;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 20px;
  background: linear-gradient(135deg, var(--accent-color), var(--muted-green));
  padding: 25px;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.06);
  transition: all 0.3s ease;
}

.contact-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.08);
}

.contact-icon {
  width: 50px;
  height: 50px;
  background-color: rgba(255, 255, 255, 0.12);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  backdrop-filter: blur(10px);
}

.contact-text {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.contact-label {
  color: var(--text-light);
  font-size: 14px;
  font-weight: 500;
  opacity: 0.95;
}

.contact-value {
  color: var(--text-light);
  font-size: 18px;
  font-weight: 700;
  text-decoration: none;
  transition: opacity 0.3s ease;
}

.contact-value:hover {
  opacity: 0.9;
}

/* ---------------- RESPONSIVE FIXES ---------------- */

@media (max-width: 1024px) {
  .about-container {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .about-content {
    padding-right: 0;
  }

  .about-white-container {
    padding: 30px;
  }

  .about-title {
    font-size: 40px;
  }
}

@media (max-width: 768px) {
  .about-section {
    padding: 40px 0;
    background-position: center bottom;
    background-size: contain;
  }

  .about-container {
    gap: 30px;
  }

  .about-white-container {
    padding: 30px;
  }

  .about-title {
    font-size: 32px;
  }

  .about-text p {
    font-size: 15px;
    text-align: left;
  }

  .contact-item {
    padding: 20px;
    flex-direction: column;
    text-align: center;
    gap: 15px;
  }

  .contact-text {
    align-items: center;
  }

  .contact-intro p {
    font-size: 16px;
  }

  .tyre-image {
    width: 120px;
  }
}

@media (max-width: 480px) {
  .about-white-container {
    padding: 20px;
  }

  .about-title {
    font-size: 28px;
  }

  .contact-item {
    padding: 15px;
  }

  .contact-value {
    font-size: 16px;
  }

  .tyre-image {
    width: 100px;
  }
}

      `}</style>
    </section>
  );
}

export default About;
